import { useNavigate } from 'react-router-dom'
import { useSingleMinigrid } from '../../../hook'
import styles from './LuminairesLink.module.scss'

export default function LuminairesLinkPresenter() {
  const navigate = useNavigate()
  const {
    singleMinigridQuery: { data: minigrid },
  } = useSingleMinigrid()

  const minigridName = minigrid?.minigrid_name?.trim() ?? ''

  if (!minigridName) return null

  const handleClick = () => {
    navigate(`/main/luminaires?minigrid=${encodeURIComponent(minigridName)}`)
  }

  return (
    <button
      type="button"
      className={styles.btn}
      onClick={handleClick}
      title={`Voir les luminaires de « ${minigridName} »`}
    >
      Voir les luminaires
    </button>
  )
}
